module.exports = __webpack_public_path__ + "img/1fa90.cdc9e7a.svg";